import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "student-groups-collapse",
  "use": "student-groups-collapse-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol viewBox=\"0 0 9 9\" xmlns=\"http://www.w3.org/2000/svg\" id=\"student-groups-collapse\"><path d=\"M9 5.25H0v-1.5h9z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol